import angular from "angular";

angular
    .module('app')
    .component('individualConfirmStudentsAttachModal', {
        template: require('./individual-confirm-students-attach-modal.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', '$scope', 'moment', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier, $scope, moment) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;
        $ctrl.students = $ctrl.resolve.students;
    };

    $ctrl.delSelectedStudent = function (student, ind) {
        student.isSelected = false;
        $ctrl.students.splice(ind, 1);
    };

    $ctrl.confirm = function () {

        let ids = [];

        $ctrl.students.forEach(v => ids.push(v.id));

        $ctrl.loading = true;

        $http
            .post(`/admin/courses/${$ctrl.course.id}/individual-training/attach-students`, {user_ids: ids})
            .then(
                function (response) {

                    $ctrl.loading = false;

                    Notifier.success('Студенты успешно добавлены', 3);

                    $ctrl.students.forEach(function (student) {
                        student.course_status = 'active';
                    });

                    $ctrl.close();
                },
                function (error) {
                    $ctrl.loading = false;
                    ErrorResponseParser.parse(error);
                }
            );
    };

}
